import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Toggle from 'material-ui/Toggle';

import { showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';

//import custom rest client
import { UPDATE } from 'admin-on-rest';
import restClient from '../../restClient';

//return <FlatButton label={ this.state.label } onClick={this.handleClick} />;
const styles = {
  block: {
    maxWidth: 250,
  },
  toggle: {
    marginBottom: 16,
  },
  thumbOff: {
    backgroundColor: '#DC4834',
  },
  trackOff: {
    backgroundColor: '#ff9d9d',
  },
  thumbSwitched: {
    backgroundColor: '#298771',
  },
  trackSwitched: {
    backgroundColor: '#76BFAE',
  },
  green: {
	color: '#298771',
  },  
  red: {
	color: '#DC4834',
  }
};

class UpdateAdStatusButton extends Component {
   	constructor(props){
	    super(props);
    	this.state = { 
				enabled: props.record.ad_active === true ? true : false,
				label: props.record.ad_active === true ? 'Uitschakelen' : 'Inschakelen',				
				};
  	}
	
    handleClick = () => {
        const { record, showNotification } = this.props;
        const updateRecord = { id: record.id, ad_active: !record.ad_active };
        restClient(UPDATE, 'member/ads', {id: record.id, data: updateRecord} )
		   .then((response) => {
			   record.ad_active = response.data.ad_active;
                showNotification('aor.notification.updated','confirm');
				this.setState({enabled : response.data.ad_active });
                //push('/member/ads');
            })
            .catch((e) => {
                console.error(e);
                showNotification('cloudhints.error_try_again','warning')
            });
    }

    render() {
		 if(this.props.record.calc_row === true) return ''
		 else if(this.props.record.user_can_bid === false || this.props.record.user_can_bid === 0) {
			return this.state.enabled ? <span style={styles.green}>Volgens afspraak</span> : <span style={styles.red}>Volgens afspraak</span>			
		 } else {		
			return  <Toggle
			  label=""
			   toggled={!!this.state.enabled}
			  onToggle={this.handleClick}
			   thumbStyle={styles.thumbOff}
			  trackStyle={styles.trackOff}
			  thumbSwitchedStyle={styles.thumbSwitched}
			  trackSwitchedStyle={styles.trackSwitched}
			/>
		 }
    }
}

UpdateAdStatusButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(UpdateAdStatusButton);


// WEBPACK FOOTER //
// ./src/ads/buttons/UpdateAdStatusButton.js